import React from 'react'
import { Link } from 'react-router-dom'
import DirectoryList from './DirectoryList'
import ParentDirectory from './ParentDirectory'
import dateHelper from '../../util/dateFormatter'
import { Translation } from 'react-i18next'
import i18n from '../../languages/lang.js'

const FileList = props => {
  if (!props.data) {
    return (
      <Translation>
        {
          (t) => (
            <div id={'loading'}>{t('system.loading')}</div>
          )
        }
      </Translation>
    )
  }

  // if (props.data.length === 0) {
  //   return (
  //     <div>
  //       <DirectoryList data={props.directions} />
  //       <div className={'empty-list'}>
  //         Upload a file...
  //     </div>
  //     </div>
  //   )
  // }

  return (
    <Translation>
      {
        (t) => (
          <table className='table-list-simple'>
            {/*<thead>
        <tr>
          <th>name</th>
          <th>views</th>
          <th>owner</th>
          <th>access</th>
          <th className='last'>created</th>
        </tr>
      </thead>*/}
            <tbody>
              <ParentDirectory data={props.directory} />
              <DirectoryList data={props.directories} />
              {
                props.data.map(item => {
                  return (
                    <tr key={item.key}>
                      <td className='important'>
                        <Link to={`/files/${item.key}`}>{item.name}</Link>
                      </td>
                      <td className='sub'>
                        <Link to={`/files/${item.key}`}>
                          {
                            item.views > 1 ?
                              <span>{item.views} views</span> : <span>{item.views} view</span>
                          }
                        </Link>
                      </td>
                      <td className='sub'>
                        <Link to={`/files/${item.key}`}>{item.owner}</Link>
                      </td>
                      <td className='sub last'>
                        <Link to={`/files/${item.key}`}>{dateHelper.Formatter.toLocalString(item.created)}</Link>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        )
      }
    </Translation>
  )
}

export default FileList
